<template>
    <div>
        <form id="clienteForm" @submit.prevent="submit()" class="ajax_off">
            <div class="form-group" v-if="parceiro.is_ar">
                <label>Parceiro</label>
                <e-select name="user_id" v-model.number="cliente.user_id" route="parceirosSelect" />
            </div>
            <div class="form-group">
                <label>Colaborador Responsável</label>
                <e-select :custom_option="{ text: 'TODOS', value: null }" name="responsavel_id"
                    v-model.number="cliente.responsavel_id" route="colaboradores" />
            </div>
            <div class="form-group">
                <label>CNPJ / CPF</label>
                <div class="input-group">
                    <the-mask name="cliente_documento" class="form-control"
                        :disabled="cliente_id && cliente.cliente_documento" v-model="cliente.cliente_documento"
                        @input="getCnpj()" :mask="['###.###.###-##', '##.###.###/####-##']" />
                    <div class="input-group-append" v-if="cliente.id && cliente.cliente_documento.length === 14">
                        <b-button variant="primary" @click="days = 1; getCnpj()" v-b-popover.hover.top="`Sincronizar dados com a Receita Federal`"><i class="fas fa-sync-alt"></i></b-button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label>Código</label>
                    <input type="text" class="form-control" v-model="cliente.codigo" />
                </div>
                <div class="col-md-6">
                    <label>Inscrição Estadual</label>
                    <input type="text" class="form-control" v-model="cliente.inscricao_estadual" />
                </div>
            </div>

            <div class="form-group" v-if="cliente.cliente_documento && cliente.cliente_documento.length == 14
                ">
                <label>Fantasia</label>
                <input type="text" name="fantasia" class="form-control" v-model="cliente.fantasia" />
            </div>
            <div class="form-group">
                <label>Razão Social / Nome</label>
                <input type="text" name="razao_social" class="form-control"
                    :readonly="cliente_id && cliente.cliente_documento && cliente.cliente_documento.length == 14"
                    v-model="cliente.razao_social" />
            </div>


            <div class="form-group">
                <label>CEP</label>
                <input type="text" name="cep" class="form-control" v-model="cliente.cep" @keyup="getCep()"
                    v-mask="'#####-###'" />
            </div>
            <div class="form-group">
                <label>Estado</label>
                <e-select v-model.trim="cliente.uf" route="estados" />
            </div>

            <div class="form-group " v-if="cliente.uf && cliente.cep">
                <label>Município</label>
                <e-select v-model.trim="cliente.municipio" :route="`municipios/ufstring/${cliente.uf}`" />
            </div>

            <div class="form-group row" v-if="cliente.municipio">
                <div class="col-md-10">
                    <label>Logradouro</label>
                    <input type="text" v-model="cliente.logradouro" name="logradouro" class="form-control "
                        placeholder="Logradouro" required="" />
                </div>

                <div class="col-md-2">
                    <label>Nº</label>
                    <input type="text" name="numero" v-model="cliente.numero" class="form-control " required="" />
                </div>
            </div>

            <div class="form-group" v-if="cliente.municipio">
                <label>Complemento</label>
                <input type="text" name="complemento" v-model="cliente.complemento" class="form-control "
                    placeholder="Complemento" />
            </div>

            <div class="form-group" v-if="cliente.municipio">
                <label>Bairro</label>
                <input type="text" name="bairro" v-model="cliente.bairro" class="form-control " placeholder="Bairro"
                    required="" />
            </div>

            <div class="form-group">
                <label>Email</label>
                <input type="email" name="email" v-model="cliente.email" class="form-control " placeholder="Email"
                    required="required" />
            </div>

            <div class="form-group row">
                <div class="col-md-6">
                    <label>Telefone Fixo</label>
                    <input type="tel" name="telefone_1" v-model="cliente.telefone" class="form-control"
                        placeholder="(00)33333-3333" />
                </div>
                <div class="col-md-6">
                    <label>Whatsapp/Celular</label>
                    <the-mask name="whatsapp" class="form-control" placeholder="(00)999999999" v-model="cliente.whatsapp"
                        :mask="'(##)#########'" />
                </div>

            </div>
            <ativar-alvara form_cliente :cliente_id="cliente.id" v-if="cliente_id && wait_cliente"
                :alvaras="cliente.alvaras" @updateAlvaras="updateArraylistAlvaras" />
            <ativar-alvara form_cliente :cliente_id="cliente.id" v-else-if="!cliente_id"
                @updateAlvaras="updateArraylistAlvaras" />
        </form>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import AtivarAlvara from "../../alvaras/forms/AtivarAlvara.vue";
export default {
    components: { AtivarAlvara },
    props: {
        cliente_id: Number,
    },
    data() {
        return {
            reload: false,
            wait_cliente: false,
            days: "",
            cliente: {
                user_id: null,
                responsavel_id: null,
                id: null,
                alvaras: [],
                alvaras_tipos: [],
                razao_social: null,
                fantasia: null,
                cliente_documento: null,
                bairro: null,
                municipio: null,
                email: null,
                cep: null,
                uf: null,
                logradouro: null,
                complemento: null,
            },
        };
    },
    computed: {
        ...mapState("user", ["user", "parceiro"]),
    },
    created() {
        if (this.parceiro.is_ar) {
            this.cliente.user_id = null;
            this.cliente.responsavel_id = null;
        }

        if (this.cliente_id) this.getCliente();
    },
    methods: {
        async getCliente() {
            this.wait_cliente = false;
            const result = await this.$api.get(`cliente/${this.cliente_id}`);
            this.cliente = result.data;

            this.cliente.fantasia = this.cliente.nome_loja;

            if (result.data.razao_social == null || result.data.razao_social == "")
                this.cliente.razao_social = result.data.nome_loja;

            this.cliente.telefone = result.data.telefone_1;
            this.cliente.celular = result.data.telefone_2;

            this.wait_cliente = true;
        },
        async submit() {
            let result = "";
            if (this.cliente_id) {
                result = await this.$api.put(
                    `cliente/${this.cliente_id}`,
                    this.cliente
                );
            } else {
                result = await this.$api.post("cliente", this.cliente);
            }

            this.$emit("updated", result.data.cliente_id);

            this.$bvModal.hide("cliente");

            if (this.cliente.alvaras_tipos && this.cliente.alvaras_tipos.length > 0)
                this.$bvModal.show("alvara");
        },

        async getCnpj() {
            if (this.cliente.cliente_documento.length === 14) {
                this.cliente.municipio = null;
                const result = await this.$api.get(
                    `cliente/receitaws/${this.cliente.cliente_documento}/${this.days}`
                ).catch((error) => {
                   if(error.response.data.status  == "404"){
                    this.$swal({
                        icon: "warning",
                        title: `Não foram encontrados os dados deste CNPJ, tente novamente mais tarde!`
                    });
                   }
                });
                if (result.data.result) {
                    this.cliente.razao_social = result.data.result.nome;

                    if (!this.cliente.fantasia)
                        this.cliente.fantasia = result.data.result.fantasia;

                    if(this.days == 1)
                        this.cliente.fantasia = result.data.result.fantasia;

                    this.cliente.uf = result.data.result.uf;
                    this.cliente.cep = result.data.result.cep;
                    this.cliente.numero = result.data.result.numero;
                    this.cliente.bairro = result.data.result.bairro;
                    this.cliente.logradouro = result.data.result.logradouro;
                    this.cliente.complemento = result.data.result.complemento;


                    this.cliente.municipio = "selecionando...";

                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.cliente.municipio = result.data.result.municipio;    
                        }, 500);
                    });



                    // this.cliente.email = result.data.result.email;
                }

                // this.getCep()
            }
        },

        async getCep() {

            let cep = this.cliente.cep.replace(/\D/g, "");

            if (cep.length >= 8) {
                const apiaxios = axios.create({
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                    withCredentials: false
                })
                const result = await apiaxios.get(
                    `https://viacep.com.br/ws/${this.cliente.cep}/json`,

                );

                if (result.data) {
                    this.cliente.uf = result.data.uf;
                    this.cliente.municipio = result.data.localidade;
                    this.cliente.bairro = result.data.bairro;
                    this.cliente.logradouro = result.data.logradouro;
                    this.cliente.complemento = result.data.complemento;
                }


            }
        },

        updateArraylistAlvaras(list) {
            this.cliente.alvaras_tipos = list;
        },
    },
};
</script>
